import styled from 'styled-components';

const StyledDirectionLine = styled.div`
  img {
    height: 56px;
  }
`;

export {StyledDirectionLine};
